import { type MessageDescriptor, defineMessage } from 'react-intl';
import { paramsKeys } from './params';

const notificationKeys = {
  EMAIL_CHANGED_NOTIFICATION: 'emailChanged',
  ROUTER_CREATED: 'routerCreated',
  ROUTER_CREATION_ERROR: 'routerCreationError',
  DEVICE_LIMIT_EXCEEDED: 'deviceLimitExceeded',
  DEVICE_DELETED: 'deviceDeleted',
  DEVICE_DELETION_ERROR: 'deviceDeletionError',
  ROUTER_NAME_CHANGED: 'routerNameChanged',
  ROUTER_NAME_CHANGE_ERROR: 'routerNameChangeError',
} as const;

type NotificationKey = (typeof notificationKeys)[keyof typeof notificationKeys];

const isNotificationKey = (key: string): key is NotificationKey =>
  Object.values(notificationKeys).includes(key as NotificationKey);

const notificationData: Record<NotificationKey, { text: MessageDescriptor; kind: 'success' | 'error' }> = {
  [notificationKeys.EMAIL_CHANGED_NOTIFICATION]: {
    kind: 'success',
    text: defineMessage({
      id: 'profile.notifictions.emailChanged',
      defaultMessage: 'Email has been changed successfully',
    }),
  },
  [notificationKeys.ROUTER_CREATED]: {
    kind: 'success',
    text: defineMessage({
      id: 'profile.notifictions.routerCreated',
      defaultMessage: 'Configuration file downloaded successfully',
    }),
  },
  [notificationKeys.ROUTER_CREATION_ERROR]: {
    kind: 'error',
    text: defineMessage({
      id: 'profile.notifictions.routerCreationError',
      defaultMessage: 'Configuration file downloading failed. Please try again',
    }),
  },
  [notificationKeys.DEVICE_LIMIT_EXCEEDED]: {
    kind: 'error',
    text: defineMessage({
      id: 'profile.routerSection.errors.deviceLimitExceeded',
      defaultMessage: 'Device limit exceeded. Delete a device to add a new one.',
    }),
  },
  [notificationKeys.DEVICE_DELETED]: {
    kind: 'success',
    text: defineMessage({ id: 'profile.notifictions.deviceDeleted', defaultMessage: 'Device was deleted' }),
  },
  [notificationKeys.DEVICE_DELETION_ERROR]: {
    kind: 'error',
    text: defineMessage({
      id: 'profile.notifictions.deviceDeletionError',
      defaultMessage: 'Device deletion failed. Please try again',
    }),
  },
  [notificationKeys.ROUTER_NAME_CHANGED]: {
    kind: 'success',
    text: defineMessage({
      id: 'profile.notifictions.routerNameChanged',
      defaultMessage: 'Device name changed successfully',
    }),
  },
  [notificationKeys.ROUTER_NAME_CHANGE_ERROR]: {
    kind: 'error',
    text: defineMessage({
      id: 'profile.notifictions.routerNameChangeError',
      defaultMessage: 'Device name change failed. Please try again',
    }),
  },
};

const genereteProfileLinkWithNotification = (notification: NotificationKey) => {
  return `/profile?${paramsKeys.PROFILE_NOTIFICATION}=${notification}`;
};

export {
  notificationKeys,
  isNotificationKey,
  type NotificationKey,
  notificationData,
  genereteProfileLinkWithNotification,
};
